import { selectKrcGoalSetNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType, RequiredType } from '@nodeTypeConfig/configTypes';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const KRC_GOAL_SET: BuildingBlockNodeConfig = {
  nodeSelector: selectKrcGoalSetNode,
  information: {
    single: 'Doelenset',
    plural: 'Doelensets',
  },
  buildingBlocks: [{ type: NodeType.KRC_AGE_RANGE }],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
      required: RequiredType.ERROR,
    },
    descriptionComponent,
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default KRC_GOAL_SET;
